var _ = require('underscore'),
    RedactionShapeView = require('../redactionShape'),
    FullPageRedactionCodeLettersView = require('./codeLetters'),
    fvChannel = require('glRadio').channel('FV');

/**
 * Note: dialog now printed inside noteView -- don't need to set the Dialog Constructor
 * for the 'super' ShapeViewDialog View Class.
 */

module.exports = RedactionShapeView.extend({

    CodeLettersView: FullPageRedactionCodeLettersView,

    shapeSubs: _.extend( {}, RedactionShapeView.prototype.shapeSubs, {
        'shape.onAfterBaseScale': 'resetGlow' // ( note: codeLetters sub-view also listens for this but they shouldn't collide)
    }),

    shapeUIEvents: _.extend( {}, RedactionShapeView.prototype.shapeUIEvents, {
        'fullPgRedactionShape:layerAfterShapesRendered':    'layerAfterAllShapesRendered'
    }),

    /**
     * Called on canvas' renderShapes.
     * Do like this for now; could employ more sophisticated layering schema from a model later on.
     */
    layerAfterAllShapesRendered: function() {

        var applyAllRedactionsMode =
            fvChannel.request('localStorage').getPgModeApplyAllRedactions();

        if ( !applyAllRedactionsMode ) {

            // Move to the back -- if were shapes were underneath, we don't capture capture mouseover events
           this.el.toBack();

        } else {

            /**
             * Position in front of all shapes -- the others won't be visible unless toggleActive, toggleExpanded, toggleHighlight.
             * - active: we don't require any changes; create will put in front and modify we cause a re-render of all shapes
             * - expanded: will temporary be brought in front
             * - highlight: when hover of notes, glow is brought to the front as an indicator
             */
            this.el.toFront();

        }

        // Update the position of the reason codes sub view
        this.trigger('redactionShape.layerCodesView');

    },

    /**
     * Dirty but works turn off 'selection.'
     * All activity is disabled when you can't select, eg drag, buttons, etc.
     */
    toggleSelected: function() {},

    // Now only occurs on entry -- just make the cursor default,
    // to indicate its not selectable.
    // Could create an 'isSelectable' property to distinguish this and make it more generic.
    toggleActive: function() {
        RedactionShapeView.prototype.toggleActive.apply( this, arguments );
        this.el.attr('cursor', 'default');
    },

    /**
     * getNonPathActiveSVGAttrs.stroke-width is 0; utilize the glow so for it to stand out.
     * Note: don't override with makeExpandedVisibleIndicator with toggle glow (we still want the base)
     */
    makeExpandedVisibleIndicator: function() {

        RedactionShapeView.prototype.makeExpandedVisibleIndicator.apply( this, arguments ); // ( if apply redactions, it shouldn't be see through here )
        this._createGlow();

    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/redaction/fullPageRedaction/fullPageRedactionShape.js
 ** module id = 316
 ** module chunks = 0
 **/